import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const ShareIcon = ({ ariaLabel = 'Map', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
      data-testid="share-icon"
    >
      {title && <title>{title}</title>}
      <path
        d="M3 10.1667V17.6667C3 19.3235 4.34315 20.6667 6 20.6667H18C19.6569 20.6667 21 19.3235 21 17.6667V10.1667"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8.64985 5.96655L11.9497 2.66671M11.9497 2.66671L15.2495 5.96655M11.9497 2.66671L11.9497 13.6667"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
